import { EventScoreboard, IcehockeyPeriodGameScore } from '@frontend/sports/betting-offer/feature/model';

import { PairScoreboardViewModel } from './pair-scoreboard.viewmodel';
import { PenaltyShootoutScoreboardStats, ScoreboardStat } from './scoreboard-stats';

export class PenaltyShootoutScoreboardViewModel extends PairScoreboardViewModel {
    override stats: PenaltyShootoutScoreboardStats;
    constructor() {
        super();
        this.stats = new PenaltyShootoutScoreboardStats();
    }

    protected override fillFromScoreboard(scoreboard: EventScoreboard): void {
        super.fillFromScoreboard(scoreboard);
        this.stats.setPenalties(scoreboard.getScore<IcehockeyPeriodGameScore>());
    }

    override updateFromScoreboard(scoreboard: EventScoreboard): void {
        super.updateFromScoreboard(scoreboard);
        this.stats.setPenalties(scoreboard.getScore<IcehockeyPeriodGameScore>());
    }

    override get score(): ScoreboardStat {
        return this.stats.values[this.scoreKey];
    }
}
